import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultLink, TSchemaAddLink } from '../../types'

export const useDefaultsLinkPost = () => {
  const path: string = '/api/Organization/DefaultLink'

  const [addLink, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<TSchemaAddLink, IDefaultLink>({
    path: path,
    method: 'POST',
    headers: {},
    errorMessage: 'Failed to add new link',
    successMessage: 'Link successfully added',
  })

  return { addLink, returnData, isLoading, isSuccess, isError }
}
